export default __webpack_public_path__ + "locales/pl/SmartBanner.json?hash=88092c6ed3f33326941f3f8ae2ff47ac";